import tiposDeExame from 'globals/tiposDeExame'
import { rem } from 'polished'

export const downloadURL = (url, filename) => {
  const a = document.createElement('a')
  a.download = filename
  a.target = '_blank'
  a.href = url
  document.body.appendChild(a)
  a.click()
  a.remove()
}

export const removerExtensao = (nomeArquivo) => {
  if (!nomeArquivo) return nomeArquivo

  const ultimoPonto = nomeArquivo.lastIndexOf('.')

  if (ultimoPonto === -1) return nomeArquivo

  return nomeArquivo.substring(0, ultimoPonto)
}

export const validarData = (valor) => {
  // Verifica se a entrada é uma string
  if (typeof valor !== 'string') {
    return false
  }

  // Verifica formado da data
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(valor)) {
    return false
  }

  // Divide a data para o objeto "data"
  const partesData = valor.split('/')
  const data = {
    dia: partesData[0],
    mes: partesData[1],
    ano: partesData[2],
  }

  // Converte strings em número
  const dia = parseInt(data.dia)
  const mes = parseInt(data.mes)
  const ano = parseInt(data.ano)

  // Dias de cada mês, incluindo ajuste para ano bissexto
  const diasNoMes = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

  // Atualiza os dias do mês de fevereiro para ano bisexto
  if (ano % 400 === 0 || (ano % 4 === 0 && ano % 100 !== 0)) {
    diasNoMes[2] = 29
  }

  // Regras de validação:
  // Mês deve estar entre 1 e 12, e o dia deve ser maior que zero
  if (mes < 1 || mes > 12 || dia < 1) {
    return false
  }

  if (ano === 0) {
    return false
  }
  // Valida número de dias do mês
  else if (dia > diasNoMes[mes]) {
    return false
  }

  // Passou nas validações
  return true
}

export const downloadBlob = (data, fileName, mimeType) => {
  const blob = new Blob([data], {
    type: mimeType,
  })

  const url = window.URL.createObjectURL(blob)

  downloadURL({ url, fileName })

  setTimeout(() => window.URL.revokeObjectURL(url), 1000)
}

export const BASE_FONT_SIZE = '16px'

export const pxToRem = (pxUnit, base = BASE_FONT_SIZE) => rem(pxUnit, base)

/** usado para limitar enquanto preenche os dados */
export const maxLength = (text, length) => {
  let result = text
  if (result.length > length) {
    result = result.substring(0, result.length - 1)
  }
  return result
}

export const cutMaxLength = (text, length) => {
  let result = text
  if (result.length > length) {
    result = result.substring(0, length)
  }
  return result
}

export const maxLengthAndNumber = (valor, length) => {
  let result = valor
  result = result.replace(/[^0-9]/g, '') // Substitui tudo que não for número
  if (result.length > length) {
    result = result.substring(0, length)
  }
  return result
}

export const capitalizeWords = (text) => {
  const words = text.split(' ')
  const capitalizedWords = []

  for (let i = 0; i < words.length; i += 1) {
    const word = words[i]

    // Verifica se a palavra deve ser mantida em minúsculas
    if (['de', 'da', 'ou', 'e', 'para'].includes(word.toLowerCase())) {
      capitalizedWords.push(word.toLowerCase())
    } else {
      const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      capitalizedWords.push(capitalizedWord)
    }
  }

  return capitalizedWords.join(' ')
}

export const capitalizeFirstLetter = (text) => {
  if (text) {
    const lowerCaseText = text.toLowerCase()
    const capitalizedText = lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1)
    return capitalizedText
  }
  return ''
}

export const capitalizeFirstLetterPhrase = (text) => {
  if (!text) return ''

  const lowercasePrepositions = ['de', 'da', 'do', 'dos', 'das']

  return text
    .toLowerCase()
    .split(' ')
    .map((word, index) => {
      if (lowercasePrepositions.includes(word) && index !== 0) {
        return word
      }
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join(' ')
}

export const formatStringList = (text, capitalizeEach = true) => {
  if (!text) return '';
  const lowercasePrepositions = ['de', 'da', 'do', 'dos', 'das'];
  let _text = text
    ?.replace('; ', ', ')
    ?.split(', ')
    ?.map(it => it
      ?.split(' ')
      ?.map(w => ((capitalizeEach && !lowercasePrepositions.includes(w)) ? capitalizeFirstLetter(w) : w.toLowerCase()))?.join(' '))
    ?.filter(Boolean)
    ?.join(', ');
  if (_text?.length > 0) return _text.charAt(0).toUpperCase() + _text.slice(1) + ".";
  return '';
}

export const identificadorMask = (value) =>
  value
    .replace(/[^A-Za-z0-9-]/g, '')
    .replace(/^([A-Za-z0-9]{2})([A-Za-z0-9])$/, '$1-$2')
    .replace(/^([A-Za-z0-9]{2}[-][A-Za-z0-9]{4})([A-Za-z0-9])$/, '$1-$2')
    .replace(/([A-Za-z0-9]{2}[-][A-Za-z0-9]{4}[-][A-Za-z0-9]{4})(\w)/, '$1')
    .toUpperCase()

export const toUpperCase = (string) => string.toUpperCase()
export const upFirstLetter = (string) => `${string[0].toUpperCase()}${string.substring(1, string.length).toLowerCase()}`
export const getPrimeiroNome = (string) => upFirstLetter(string.split(' ')[0])
export const getNomeCurto = (string) => {
  const nomes = string.split(' ')
  if (nomes.length > 1) {
    return `${upFirstLetter(nomes[0])} ${upFirstLetter(nomes[nomes.length - 1])}`
  }
  return upFirstLetter(nomes[0])
}

export const hasDocumentoSolicitacao = (codigoExame) => {
  const tiposComSolicitacao = [
    // TOXICOLOGIA
    tiposDeExame.TOXICOLOGICO_POST_MORTEM_DAF,
    tiposDeExame.TOXICOLOGICO_POST_MORTEM_PEST,
    tiposDeExame.DOSAGEM_ALCOOLICA,
    tiposDeExame.TOXICOLOGICO_ALCOOLEMIA_VIVO,
    tiposDeExame.TOXICOLOGICO_FARMACOS_DROGAS,
    tiposDeExame.TOXICOLOGIA_MATRIZES,
    tiposDeExame.TOXICOLOGICO_SOLVENTES_ORGANICOS,
    tiposDeExame.TOXICOLOGICO_INVIVO_AGROTOXICO,
    // DNA
    tiposDeExame.DNA,
    // BIOLOGIA
    tiposDeExame.PESQUISA_SANGUE_HUMANO,
    tiposDeExame.ESPERMATOSOIDE_PSA,
    tiposDeExame.GRAVIDEZ,
    tiposDeExame.MATERIAL_CAPILAR_HUMANO
  ]
  return tiposComSolicitacao.includes(codigoExame)
}

export const verificarTipoVestigioGenericoEmVestigio = (vestigio, tipo) => {
  if (!vestigio?.tiposGens) return false
  let result = false
  vestigio.tiposGens.forEach((tipoGenerico) => {
    if (tipoGenerico.identificador === tipo) {
      result = true
    }
  })
  return result
}

export const verificarTipoEspecificoEmVestigio = (vestigio, tipo) => {
  if (!vestigio?.tiposEsps) return false
  let result = false
  vestigio.tiposEsps.forEach((tipoEspecifico) => {
    if (tipoEspecifico.identificador === tipo) {
      result = true
    }
  })
  return result
}

export const getVestigioRestricoes = (options, tipoExame) => {
  let result = []
  if (tipoExame.restricao) {
    switch (tipoExame.restricao) {
      case 'REST1': {
        options.forEach((option) => {
          if (option?.cadavOrig?.id) {
            result.push(option)
          }
        })
        break
      }
      // ALCOOLEMIA
      case 'REST2': {
        options.forEach((option) => {
          if (verificarTipoEspecificoEmVestigio(option, 'HUMOR_VITREO') || verificarTipoEspecificoEmVestigio(option, 'SANGUE') || (verificarTipoEspecificoEmVestigio(option, 'OUTRO') && verificarTipoVestigioGenericoEmVestigio(option, 'BIOLOGICO'))) {
            result.push(option)
          }
        })
        break
      }

      // SOLVENTES ORGÂNICOS
      case 'REST5': {
        options.forEach((option) => {
          if (
            verificarTipoEspecificoEmVestigio(option, 'SANGUE') ||
            verificarTipoEspecificoEmVestigio(option, 'HUMOR_VITREO') ||
            verificarTipoEspecificoEmVestigio(option, 'PULMAO') ||
            (verificarTipoEspecificoEmVestigio(option, 'OUTRO') && verificarTipoVestigioGenericoEmVestigio(option, 'BIOLOGICO'))
          ) {
            result.push(option)
          }
        })
        break
      }
      default: {
        break
      }
    }
  } else {
    result = options
  }

  return result
}

export const corPorCategoria = (categoria) => {
  if (!categoria) return '#000000'
  switch (categoria) {
    case 'A':
      return '#9e5892'
    case 'B':
      return '#ffa99c'
    case 'C':
      return '#6ac98f'
    case 'D':
      return '#c58279'
    case 'E':
      return '#526000'
    case 'F':
      return '#b38e87'
    case 'G':
      return '#ffbfe7'
    case 'H':
      return '#ffa99c'
    case 'I':
      return '#9a7a75'
    case 'J':
      return '#526000'
    case 'K':
      return '#e29d93'
    case 'L':
      return '#9c9a66'
    case 'M':
      return '#ffbfe7'
    case 'N':
      return '#ffa99c'
    case 'O':
      return '#eefff3'
    default:
      return '#000000'
  }
}
